import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import "./index.css";

/* Actions */
import { setYachts } from "../../../../redux/actions/admin";

/* API requests */
import { getAllYachts, searchYachts } from "../../../../api-requests/yacht";
import { handleYachtIcon, handleYachtName } from "../../../../helpers/job";

const SearchIcon = () => (
    <svg width={16} height={16} viewBox="0 0 24 24" fill="none">
        <circle cx={11} cy={11} r={8} stroke="currentColor" strokeWidth={2} />
        <path d="M21 21L16.65 16.65" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    </svg>
);

const PlusIcon = () => (
    <svg width={16} height={16} viewBox="0 0 24 24" fill="none">
        <path d="M12 5V19M5 12H19" stroke="currentColor" strokeWidth={2} strokeLinecap="round" />
    </svg>
);

class Yachts extends Component {

    constructor(props) {
        super(props);
        this.state = {
            keyword: "",
            searchResults: [],
            isFetchingSearchResults: false,
        };
    }

    componentDidMount() {
        const dash = document.getElementById("Dashboard");
        if (dash && dash.scrollTo) dash.scrollTo(0, 0);
        return getAllYachts().then(yachts => this.props.setYachts(yachts));
    }

    handleSearch = (keyword) => {
        return this.setState({ keyword }, () => {
            if (keyword.length >= 3) {
                return this.setState({ isFetchingSearchResults: true }, () => {
                    return searchYachts(keyword)
                        .then(result => this.setState({ searchResults: result, isFetchingSearchResults: false }));
                });
            }
            return this.setState({ searchResults: [], isFetchingSearchResults: false });
        });
    }

    handleYachtsList = (yachts, searchResults, keyword) => {
        if (searchResults.length > 0 && keyword.length >= 3) return searchResults;
        return yachts;
    }

    renderPlaceholders = (placeholders) => placeholders.map((p) => (
        <div className="yacht-row admin-card" key={p}>
            <div className="yacht-row-placeholder-icon" />
            <div className="yacht-row-placeholder-text" />
            <div className="yacht-row-placeholder-cell" />
            <div className="yacht-row-placeholder-cell" />
            <div className="yacht-row-placeholder-cell" />
        </div>
    ));

    renderYachts = (yachts) => yachts.map((yacht, index) => (
        <Link to={"/yachts/edit/" + yacht._id} className="yacht-row admin-card" key={index}>
            <div className="yacht-row-icon">
                <img src={handleYachtIcon(yacht.size, yacht.yachtType)} alt="" />
            </div>
            <div className="yacht-row-name">
                <p className="yacht-row-name-text">{handleYachtName(yacht)}</p>
            </div>
            <div className="yacht-row-cell">{yacht.age || "—"}</div>
            <div className="yacht-row-cell">{yacht.yachtBuilderName || "—"}</div>
            <div className="yacht-row-cell">{yacht.size ? `${yacht.size}m` : "—"}</div>
        </Link>
    ));

    render() {

        const yachts = this.handleYachtsList(this.props.admin.yachts, this.state.searchResults, this.state.keyword);
        const totalCount = (this.props.admin.yachts || []).length;

        return(
            <div className="admin-page">
                <header className="admin-page-header">
                    <div className="admin-page-header-titles">
                        <h1 className="admin-page-title">Yachts</h1>
                        <p className="admin-page-subtitle">{totalCount > 0 ? `${totalCount} local yacht accounts.` : "Local yacht accounts."}</p>
                    </div>
                    <Link to={"/yachts/create"} className="admin-page-action admin-page-action--primary">
                        <PlusIcon />
                        <span>New yacht</span>
                    </Link>
                </header>

                <div className="admin-toolbar no-tabs">
                    <div className="admin-search">
                        <span className="admin-search-icon"><SearchIcon /></span>
                        <input
                            type="text"
                            value={this.state.keyword}
                            onChange={(e) => this.handleSearch(e.target.value)}
                            placeholder="Search yachts"
                            className="admin-search-input"
                        />
                        {this.state.isFetchingSearchResults &&
                            <span className="admin-search-spinner">
                                <img src={require("../../../../assets/animations/blue-spinner.svg")} alt="" />
                            </span>
                        }
                    </div>
                </div>

                <div className="yacht-row-header">
                    <div className="yacht-row-header-name">Yacht</div>
                    <div className="yacht-row-header-cell">Year built</div>
                    <div className="yacht-row-header-cell">Builder</div>
                    <div className="yacht-row-header-cell">Length</div>
                </div>

                <div className="admin-card-list">
                    {!this.props.admin.isFetchingYachts
                        ? this.renderYachts(yachts)
                        : this.renderPlaceholders([1, 2, 3, 4, 5, 6, 7, 8])
                    }
                </div>
            </div>
        );
    }
}

const mapStateToProps = (state) => ({ admin: state.admin });
const mapDispatchToProps = (dispatch) => ({
    ...bindActionCreators({ setYachts }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(Yachts);
